import { Button, ButtonProps, SxProps, Typography } from '@mui/material';
import React from 'react';

interface IProps extends ButtonProps {
  children: string | React.ReactNode;
  textColor?: string;
  rootStyle?: SxProps;
  typoStyle?: SxProps;
  dataId?: string;
}
export default function LinkButton(props: IProps) {
  const {
    dataId,
    textColor,
    rootStyle,
    typoStyle,
    children,
    sx,
    ...restProps
  } = props;
  return (
    <Button
      {...restProps}
      data-id={dataId}
      sx={[
        {
          backgroundColor: 'transparent',
          '& :hover': { backgroundColor: 'transparent' },
        },
        ...(rootStyle ? (Array.isArray(rootStyle) ? rootStyle : [rootStyle]) : []),
        ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
      ]}
      variant="text"
    >
      <Typography
        variant="linkText"
        sx={{
          color: textColor ? textColor : 'secondary.main',
          ...typoStyle,
        }}
      >
        {children}
      </Typography>
    </Button>
  );
}
